<template>
  <fn-list
    unstyled
    class="f-list"
    :class="{
      'f-list--single-select': singleSelect,
      'f-list--multi-select': multiSelect,
      'f-list--brand': brand,
      'f-list--color': color,
    }"
  >
    <fn-facet-item
      v-for="item in items"
      :key="item.code"
      :href="item.query ? item.query.url : undefined"
      :selected="item.selected"
      :label="(item.searchTerm ? item.searchTerm : item.name) || 'No label defined'"
      :count="item.count"
      :color-code="item.colorCode"
      :search-term="item.searchTerm"
      :val="item.code"
      :facet="code"
      :indexable="item.indexable"
      :is-link="!isBrandPage"
      :is-child-facet="isChildFacet"
      @change="(selected) => $emit('change', { code: item.code, selected })"
    >
      <ul v-if="item.values?.length">
        <fn-facet-item
          v-for="subItem in item.values"
          :key="subItem.code"
          class="f-list-sub-item"
          :href="subItem?.query?.url"
          :selected="subItem.selected"
          :label="(subItem.searchTerm ? subItem.searchTerm : subItem.name) || 'No label defined'"
          :count="subItem.count"
          :color-code="subItem.colorCode"
          :search-term="subItem.searchTerm"
          :val="subItem.code"
          :facet="code"
          :indexable="subItem.indexable"
          :is-link="!isBrandPage"
          :is-child-facet="isChildFacet"
          @change="(selected) => $emit('change', { code: subItem.code, selected }, true, item.code)"
        />
      </ul>
    </fn-facet-item>
  </fn-list>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    items: Array<any>;
    singleSelect?: boolean;
    multiSelect?: boolean;
    color?: boolean;
    brand?: boolean;
    code: string;
    isBrandPage?: boolean;
    isChildFacet?: boolean;
  }>(),
  {
    backgroundColor: '',
    code: '',
  },
);
defineEmits(['change']);
</script>

<style lang="scss" scoped>
.f-list {
  flex-wrap: nowrap;
  overflow-y: auto;
  height: 100%;

  &.f-list--color {
    flex-wrap: wrap;
    flex-direction: row;
    height: auto;
  }

  .facet--desktop & {
    padding: 0;
  }

  .f-list-sub-item {
    padding-left: $pad;
  }

  :deep(.f-list-item) {
    ul {
      padding-left: 0;
    }
  }
}
</style>
